import {AfterContentChecked, AfterViewChecked, ChangeDetectorRef, Component, Inject, OnInit, ViewChild,} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {
    SelectCodepostalComponent
} from '../../../../../../modules/widget/components/form/select/select-codepostal/select-codepostal.component';

@Component({
    selector: 'app-edit-dialog-usine',
    templateUrl: './edit-dialog-usine.component.html',
    styleUrls: ['./edit-dialog-usine.component.css'],
})
export class EditDialogUsineComponent
    implements OnInit, AfterViewChecked, AfterContentChecked {
    t: any;
    form: FormGroup;
    @ViewChild(SelectCodepostalComponent) selectCodepostalComponent;
    filed = {
        tel_num: 'telNo',
        fax: 'faxNo',
        codepostale: 'postCd',
        address1: 'addr1',
        adreese2: 'addr2',
        name_usine: 'factoryNm',
        etrangere: 'chkRc',
    };

    constructor(
        private dialogRef: MatDialogRef<EditDialogUsineComponent, { data: any }>,
        private cdref: ChangeDetectorRef,
        @Inject(MAT_DIALOG_DATA) data: { t: any }
    ) {
        this.t = data;
    }

    getFormControl(key: string): FormControl {
        return this.form.controls[key] as FormControl;
    }

    ngOnInit(): void {

        this.form = new FormGroup({
            [this.filed.tel_num]: new FormControl(this.t?.telNo, [
                Validators.required,
            ]),
            [this.filed.codepostale]: new FormControl(
                {value: this.t?.postCd, disabled: false},
                [Validators.required]
            ),
            [this.filed.address1]: new FormControl(this.t?.addr1, [
                Validators.required,
            ]),
            [this.filed.adreese2]: new FormControl(this.t?.addr2),
            [this.filed.name_usine]: new FormControl(this.t?.factoryNm, [
                Validators.required,
            ]),
            [this.filed.fax]: new FormControl(this.t?.faxNo),
            [this.filed.etrangere]: new FormControl(this.t?.chkRc, [
                Validators.required,
            ]),
            g: new FormControl(this.t?.gouvernorat, []),
            d: new FormControl(this.t?.delegation, []),
            v: new FormControl(this.t?.ville, []),
        });
    }

    onSuccessAdd() {
        const add = this.t.addr1?.toString()?.split(',');
        if (add.length >= 3) {
            var go = add[2];
            var de = add[1];
            var vil = add[0];
        }

        const gouv = this.selectCodepostalComponent?.selectGouvernoratComponent
            ?.matselcet?.value;

        const d = this.selectCodepostalComponent?.selectDelegationComponent?.mat
            ?.value;
        const v = this.selectCodepostalComponent?.selectVilleBygouvandDelComponent
            ?.matselect?.value;
        this.form.get('g').setValue(gouv ? gouv : go);
        this.form.get('d').setValue(d ? gouv : de);
        this.form.get('v').setValue(v ? gouv : vil);
        if (this.form.valid) {
            const data = this.form.getRawValue();

            this.dialogRef.close({
                data: data,
            });
        }
    }

    ngAfterContentChecked() {
        this.cdref.detectChanges();
    }

    ngAfterViewInit(): void {
        if (!this.t.etrangere) {
            const f = this.t?.addr1.split(',');
            const ff = f[2]?.split(' ');
            const g = f[2]?.match(/\d+/g)
                ? ff[2]?.toString().trim() + ' ' + ff[3]?.toString().trim()
                : f[2]?.toString().trim();
            const d = f[1]?.toString().trim();
            const v = f[0]?.toString().trim();
            this.selectCodepostalComponent.form.get('de').enable();
            this.selectCodepostalComponent.form.get('ville').enable();

            this.selectCodepostalComponent.gouvernorat = g;
            this.selectCodepostalComponent.delegation = d;
            this.selectCodepostalComponent.ville = v;
            this.selectCodepostalComponent.selectGouvernoratComponent.control.setValue(
                g
            );

            this.selectCodepostalComponent.selectDelegationComponent.gouvernorat = g;
            this.selectCodepostalComponent.selectDelegationComponent.fetch();

            this.selectCodepostalComponent.selectDelegationComponent.control.setValue(
                d
            );
            this.selectCodepostalComponent.selectVilleBygouvandDelComponent.gouvernorat = g;
            this.selectCodepostalComponent.selectVilleBygouvandDelComponent.delegation = d;
            this.selectCodepostalComponent.selectVilleBygouvandDelComponent.fetch();
            setTimeout((x) => {
                this.selectCodepostalComponent.form.get('ville').enable();

                this.selectCodepostalComponent.selectVilleBygouvandDelComponent.control.enable();
                this.selectCodepostalComponent.selectVilleBygouvandDelComponent.control.setValue(
                    v
                );
                this.selectCodepostalComponent.gouvernorat = g;
                this.selectCodepostalComponent.delegation = d;
                this.selectCodepostalComponent.ville = v;
            }, 200);
        }
        setTimeout((x) => {
            /*   this.selectCodepostalComponent.etrangere =
              this.t?.chkRc == "Y" ? false : true;*/
            if (this.t?.chkRc == 'Y') {
                this.selectCodepostalComponent.selectGouvernoratComponent.control.setValue(
                    null
                );
                this.selectCodepostalComponent.selectDelegationComponent.control.setValue(
                    null
                );
                this.selectCodepostalComponent.selectVilleBygouvandDelComponent.control.setValue(
                    null
                );
                this.selectCodepostalComponent.selectGouvernoratComponent.control.disable();
                this.selectCodepostalComponent.selectDelegationComponent.control.disable();
                this.selectCodepostalComponent.selectVilleBygouvandDelComponent.control.disable();
            }
            if (!this.t.etrangere) {
                this.selectCodepostalComponent.controlcode.disable();
                this.selectCodepostalComponent.controladrese.disable();
            }
            this.selectCodepostalComponent.controlcode.setValue(this.t.postCd);
            this.selectCodepostalComponent.controladrese.setValue(this.t.addr1);
        }, 500);
    }

    ngAfterViewChecked(): void {
        this.cdref.detectChanges();
    }
}
